var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":"patients-library"}},[_c('router-view',{on:{"toggle-side-bar":_vm.toggleSideBar}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }